import type { ErrorResponse } from 'react-router-dom';

export class ErrorBase<TData> implements ErrorResponse {
  constructor(
    public status: number,
    public statusText: string,
    public data: TData,
  ) {}
}
